/** @jsx jsx */
import { css } from '@emotion/react';
import { borderRadius } from '@atlaskit/theme/constants';
import { N30A } from '@atlaskit/theme/colors';
export var moreEmojiContainerStyle = css({
  display: 'flex'
});
export var moreButtonStyle = css({
  opacity: 0,
  outline: 'none',
  backgroundColor: 'transparent',
  border: 0,
  borderRadius: "".concat(borderRadius(), "px"),
  cursor: 'pointer',
  margin: '4px 4px 4px 0',
  padding: '4px',
  width: '38px',
  verticalAlign: 'top',
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat(N30A, ")")
  }
});
export var separatorStyle = css({
  backgroundColor: "var(--ds-border, ".concat(N30A, ")"),
  margin: '8px 8px 8px 4px',
  width: '1px',
  height: '60%',
  display: 'inline-block'
});